import { io } from "socket.io-client";
import config from "../../config";

export const socket = io(config.API_BASE_URL, {
  transports: ["websocket", "polling"], // Enable both websocket and polling transports
  reconnectionAttempts: 5, // Retry connecting up to 5 times
  reconnectionDelay: 1000, // Wait for 1 second before retrying
});

socket.on("connect_error", (error) => {
  console.error("Socket connection error:", error);
});

socket.on("disconnect", () => {
  console.log("Socket disconnected");
});

// Register user with the server
export const registerUser = (userId) => {
  socket.emit("register-user", userId);
};
